import React from 'react'
import {findDOMNode} from "react-dom"

import HintPopover from "../../../../../src/core/gd-ui/hint-popover/hint-popover"
import NavigationMenuItemProjectMore from '../../../../../src/core/gd-ui/more/project/navigation-project-more-menu'
import MoreProject_PopoverMenu from "../../../../core/gd-ui/more/project/popover-menu"
import ProjectTypeIcon from "../../../../../src/core/gd-components/icons/project-type-icon"
import ProjectSession from "../../../../core/model2/project/project-session"

type Props = {
    style?                  : any

    report                  : ProjectSession
    level                   : number

    dndPreview?             : boolean
    colorized?              : boolean
    // hideArrow?              : boolean   // used in search to hide expand arrow pass true to hide

    onMenuItemHandleClick?  : func
    onAddInline?            : func
}

type State = {
    useHint     : boolean
    hovered     : boolean
}

// const debug = "NavigationMenu_ItemReport"
const debug = false

export default class NavigationMenu_ItemReport extends React.Component<Props, State> {

    private debouncedCheckHint  : any

    constructor(props: Props) {
        super(props)

        this.state = {
            useHint     : false,
            hovered     : false
        };

        this.debouncedCheckHint = _.debounce(this._checkHintUsage, 300)
    }

    componentDidMount() {
        this.debouncedCheckHint()
    }

    componentDidUpdate() {
        this.debouncedCheckHint()
    }

    componentWillUnmount = () => {
        this.debouncedCheckHint.cancel()
    }

    showContextMenu = (e: React.MouseEvent) => {
        gd.layout.contextMenu.show(e,
            <MoreProject_PopoverMenu project        = {gd.session.projects.get(this.props.report.id)!}
                                     hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component   : this,
                className   : 'hovered'
            }
        )
    }

    _checkHintUsage = () => {
        const useHint = gd.utils.getTextExceedsNodeWidth(this.props.report.name, findDOMNode(this), 75, 14)
        if (this.state.useHint !== useHint) {
            this.setState({
                useHint: useHint
            })
        }
    }

    onMenuItemHandleClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        if(this.props.onMenuItemHandleClick){
            this.props.onMenuItemHandleClick(this.props.report.id, e)
        }

    }

    onClick = async (e: React.MouseEvent) => {

        e.stopPropagation()

        gd.navigation.goToProject(this.props.report.id, "")
    }

    render() {
        if (!this.props.report) {
            console.error("ERROR #kdjdjh24 - how come no project found - onProjectDelete ?")
            return null
        }

        if (gd.layout.contextMenu.isShown && gd.layout.contextMenu.hover!.component.props.report.id === this.props.report.id) {
            gd.layout.contextMenu.hover!.component = this
        }

        const noAccess : boolean        = !this.props.report.access
        const isHovered : boolean       = this.state.hovered || gd.layout.contextMenu.hover?.component?.props.project?.id === this.props.report.id

        // there should not be any project without access (is there any real case?)
        if (noAccess) {
            console.warn('NavigationMenuItemProject render: project without access', this.props.report)
        }

        const classes = Classes('item', 'level-'+this.props.level, 'projectId-'+this.props.report.id /*required for scroll to node*/, {
            'dnd-preview'   : this.props.dndPreview,
            'hovered'       : isHovered,
        })

        // style is required for ReorderList (pointer-events: none)
        return (
            <div className={classes} style={this.props.style} onClick={this.onClick} onContextMenu={this.showContextMenu}>

                <div className="row">
                    <ProjectTypeIcon className  = "icon"
                                     projectId  = {this.props.report.id}
                                     colorize   = {this.props.colorized}/>
                    <div className="name">{this.props.report.name}</div>

                    {!noAccess &&
                        <>
                            {!gd.user.acl.isClient &&
                                <NavigationMenuItemProjectMore projectId    = {this.props.report.id}
                                                               parent       = {this}
                                                               showPinStar  = {true}/>}
                        </>}
                </div>

                {this.state.useHint &&
                    <HintPopover hint       = {this.props.report.name}
                                 multiline  = {true}/>
                }
            </div>
        )
    }
}
